import clsx from 'clsx';
import React from 'react';
import styles from './WideBlock.module.scss';
import { Button } from 'tt-ui-lib/core';
// import { ReactComponent as DeleteSvg } from '../../../../../../assets/svg/delete.svg';
// import { ReactComponent as EditSvg } from '../../../../../../assets/svg/edit.svg';
// import { CALC_TYPES } from 'utils/calculatorUtils';
import ReportDelete from 'views/ScoreAndReporting/components/ReportDelete/ReportDelete';
import ReportProceed from 'views/ScoreAndReporting/components/ReportProceed/ReportProceed';
import RenameInput from 'views/ScoreAndReporting/components/ReportRename/ReportRename';
import { useSelectedContext } from 'context/contextSelector';

const WideBlock = (props) => {
  const {
    draft,
    targetWidth,
    editId,
    setEditId,
    onProceedDraft,
    refresh,
    onRenameDraft,
    onViewClick,
  } = props;

  const { user } = useSelectedContext((context) => context.user);

  return (
    <div
      key={draft.id}
      className={clsx(styles.rowWrapper, targetWidth < 940 && styles.shortFormat)}
    >
      <div className={styles.summary}>
        <div className={styles.draftData}>
          <RenameInput
            id={draft.id}
            name={draft.name}
            onEditClick={() => setEditId(editId === draft.id ? null : draft.id)}
            onEditFinish={onRenameDraft}
            isEditing={editId === draft.id}
          />
          <div className={styles.calculator}>{draft?.calculator ?? `calculator`}</div>
        </div>
        <div className={styles.info}>
          <div className={styles.dataItem}>
            <p className={styles.dataName}>Edited:</p>
            <p className={styles.dataValue}>
              {draft?.updatedAt ? draft.updatedAt.toLocaleDateString() : ''}
            </p>
          </div>
          <div className={styles.dataItem}>
            <p className={styles.dataName}>Edited by:</p>
            <span className={styles.dataValue}>
              {user.first_name} {user.last_name}
            </span>
          </div>
        </div>
      </div>
      <div className={styles.buttonCont}>
        <ReportProceed buttonType="link" draftId={draft.id} />
        <Button style={{ textWrap: 'nowrap' }} onClick={() => onViewClick(draft.id)}>
          View more
        </Button>
        <ReportDelete
          type="icon"
          onDelete={refresh}
          draftId={draft.id}
          draftName={draft.name}
          buttonType="icon"
        />
      </div>
    </div>
  );
};

export default WideBlock;
